export const toHexColor = (color: string) => "#" + color.replace("#", "");
